import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
  },
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      paddingTop: theme.spacing(1),
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(0.5),
    },
  },
  sync: {
    display: 'flex',
    justifyContent: 'center',
    justifyItems: 'center',
    flexGrow: 1,
    margin: theme.spacing(1),
    color: 'red',
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      margin: theme.spacing(0.5),
    },
  },
  tableBox: {
    margin: theme.spacing(2, 0, 0),
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(1, 0, 0),
    },
  },
  infoContainer: {
    display: 'flex',
    height: 50,
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
      minHeight: 40,
    },
  },
  title: {
    flexGrow: 1,
    margin: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(0.5),
      fontSize: '18px',
    },
  },
  paper: {
    display: 'flex',
    justifyContent: 'center',
    justifyItems: 'center',
    flexDirection: 'column',
    boxShadow: theme.shadows[0],
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(0.5),
    },
  },
}));
